import { useRef, useState, useCallback } from 'react';
import { UploadSimple } from '@phosphor-icons/react';

const monoFont = "'IBM Plex Mono', monospace";

interface GalleryUploadZoneProps {
  uploading: boolean;
  onFiles: (files: FileList | File[]) => void;
  compact?: boolean;
}

export function GalleryUploadZone({ uploading, onFiles, compact = false }: GalleryUploadZoneProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [dropOver, setDropOver] = useState(false);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setDropOver(false);
      if (e.dataTransfer.files?.length) onFiles(e.dataTransfer.files);
    },
    [onFiles],
  );

  return (
    <>
      <div
        onDrop={handleDrop}
        onDragOver={(e) => {
          e.preventDefault();
          if (e.dataTransfer.types.includes('Files')) setDropOver(true);
        }}
        onDragLeave={() => setDropOver(false)}
        onClick={() => fileInputRef.current?.click()}
        className={`cursor-pointer flex items-center justify-center gap-2 ${compact ? 'py-3 mb-3' : 'flex-col py-8 mb-4'}`}
        style={{
          border: dropOver
            ? '1px dashed rgba(247,246,242,0.4)'
            : '1px dashed rgba(247,246,242,0.2)',
          backgroundColor: dropOver ? 'rgba(247,246,242,0.02)' : 'transparent',
          fontFamily: monoFont,
          opacity: uploading ? 0.5 : 1,
          pointerEvents: uploading ? 'none' : 'auto',
          transition: 'border-color 0.15s ease, background-color 0.15s ease',
        }}
      >
        <UploadSimple size={compact ? 16 : 24} weight="thin" style={{ color: 'rgba(247,246,242,0.3)' }} />
        <span style={{ fontSize: compact ? 10 : 12, fontWeight: 300, color: 'rgba(247,246,242,0.4)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {uploading ? 'Otimizando e enviando...' : 'ARRASTE IMAGENS AQUI OU CLIQUE PARA ENVIAR'}
        </span>
        {!compact && (
          <span style={{ fontSize: 12, fontWeight: 300, color: 'rgba(247,246,242,0.25)', textTransform: 'uppercase' }}>
            JPG, PNG, WEBP — máx. 20MB · Otimização automática
          </span>
        )}
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept=".jpg,.jpeg,.png,.webp"
        multiple
        className="hidden"
        onChange={(e) => {
          if (e.target.files) onFiles(e.target.files);
          e.target.value = '';
        }}
      />
    </>
  );
}